// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InfoWindowDockingType;
(function (InfoWindowDockingType) {
    InfoWindowDockingType[InfoWindowDockingType["None"] = 0] = "None";
    InfoWindowDockingType[InfoWindowDockingType["Top"] = 1] = "Top";
    InfoWindowDockingType[InfoWindowDockingType["Bottom"] = 2] = "Bottom";
})(InfoWindowDockingType || (InfoWindowDockingType = {}));
